export enum BusinessAccidentPayment {
  EMPLOYER = 'EMPLOYER',
  EMPLOYEE = 'EMPLOYEE',
}

export const getBusinessAccidentPaymentLabel = (object: BusinessAccidentPayment) => {
  switch (object) {
    case BusinessAccidentPayment.EMPLOYER:
      return $localize`Employeur`;
    case BusinessAccidentPayment.EMPLOYEE:
      return $localize`Salarié`;
    default:
      return '';
  }
};
